import history from 'lib/history';

// IE10+ compatible
export function removeHash() {
  const { pathname, search } = history.location;

  history.replace(pathname + search);
}
